var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgYs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 299.84 226.067",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.073 226.067c-13.837 0-25.173-1.064-34.006-3.194-8.835-2.128-16.658-5.428-23.47-9.897l11.814-36.081c4.47 2.98 9.633 5.428 15.486 7.344 5.855 1.916 12.507 2.873 19.958 2.873 8.941 0 16.072-2.341 21.394-7.024 5.322-4.684 7.983-11.07 7.983-19.159 0-7.237-2.236-13.198-6.705-17.881-4.471-4.683-13.466-10.058-26.983-16.125-13.517-6.067-23.683-14.475-30.495-25.225-6.812-10.75-10.217-22.085-10.217-34.006 0-19.157 6.387-35.23 19.159-48.215C202.763 6.492 219.58 0 240.443 0c11.708 0 21.66 1.064 29.854 3.193 8.196 2.128 15.382 5.322 21.555 9.579l-10.857 31.61a64.353 64.353 0 00-15.008-7.023c-5.322-1.703-11.282-2.555-17.882-2.555-17.668 0-26.502 8.408-26.502 25.225 0 7.451 2.341 13.518 7.025 18.2 4.683 4.683 14.528 10.378 29.536 17.083 15.008 6.705 25.705 15.273 32.09 25.704 6.387 10.43 9.58 22.457 9.58 36.081 0 19.798-6.865 36.242-20.595 49.332-13.731 13.092-31.452 19.638-53.166 19.638",
    fill: "#5a9f23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.843 130.595v92.28H58.115v-92.28L0 3.193h54.283l31.612 83.019L119.74 3.193h48.856",
    fill: "#4f4c4c"
  }))));
}

export default __webpack_public_path__ + "7856977f37e10f7742fcd510285f7d5d.svg";
export { SvgYs as ReactComponent };